import { render } from "./CaregiversPage.vue?vue&type=template&id=51096de5&ts=true"
import script from "./CaregiversPage.vue?vue&type=script&lang=ts"
export * from "./CaregiversPage.vue?vue&type=script&lang=ts"

import "./CaregiversPage.vue?vue&type=style&index=0&id=51096de5&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/Caregivers/CaregiversPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51096de5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51096de5', __exports__)) {
    api.reload('51096de5', __exports__)
  }
  
  module.hot.accept("./CaregiversPage.vue?vue&type=template&id=51096de5&ts=true", () => {
    api.rerender('51096de5', render)
  })

}


export default __exports__